// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"b59222c0","787":"e0f3b9ac","850":"e8c32e22"}[chunkId] + ".chunk.js";
};